<div *ngIf="formGroup" class="user-group-select-container">
  <pt-input-label
    *ngIf='label'
    [inputId]='inputId'
    [isRequired]='isRequired'
    [label]='label'
    style='display: contents'
  ></pt-input-label>
  <div
    [class.is-invalid]='formGroup.invalid && formGroup.touched'
    [class.ng-dirty]=formGroup.dirty
    [class.ng-invalid]='formGroup.invalid && formGroup.touched'
    [class.ng-touched]=formGroup.touched
    [class.ng-valid]=formGroup.valid
    class='form-control form-control-sm ng-select-multiple-control ng-select-multiple-control-lg mb-3'>
    <ng-select
      [(ngModel)]="dialogSelectedMembers"
      [closeOnSelect]="false"
      [disabled]="dialogMembers.length === 0"
      [hideSelected]="false"
      [id]='inputId'
      [items]='dialogMembers'
      [multiple]='true'
      [placeholder]='placeholder'
      [readonly]='disabled'
      [searchFn]="customSearchFn"
      bindLabel='{{options?.bindLabel}}'
      style="min-height: 30px;">

      <ng-template let-clear="clear" let-items="items" ng-multi-label-tmp>
        <div *ngFor="let item of items | slice:0:1" class="ng-value">
            <span class="ng-value-label">
               {{ $any(item).fullName }}
            </span>
          <span (click)="clear(item)" aria-hidden="true" class="ng-value-icon right">×</span>
        </div>
        <div *ngIf="items && items.length > 1" class="ng-value">
          <span class="ng-value-label">{{ items.length - 1 }} more...</span>
        </div>
      </ng-template>

      <ng-template let-index="index" let-item="item" let-search="searchTerm" ng-option-tmp>
        <span [innerHTML]="item.fullName | highlight: search"></span>
        <br/>
        <small [innerHTML]="item.email | highlight: search"></small>
      </ng-template>

    </ng-select>
    <button (click)='addMember()' [disabled]="dialogSelectedMembers.length === 0"
            class='btn btn-outline-dark btn-sm'
            style="max-height: 30px;"
            type='button'>
      {{ 'BUTTON.ADD' | translate }}
    </button>
  </div>
  <small
    [innerHTML]='help'
    class='form-text text-muted' id='ptWFilteredSelectHelp_{{controlName}}'
  ></small>
</div>

<ag-grid-angular
  *ngIf='gridOptions && columnsDef && columnsDef.length > 0'
  [columnDefs]='columnsDef'
  [gridOptions]='gridOptions'
  [rowData]='selectedMembers'
  class='ag-theme-balham w-100'
  style='height: 200px'>
</ag-grid-angular>

<ng-template #actionCol let-node>
  <pt-icon (click)='removeMember(node.row)' [key]='IconRemove' class='cursor-pointer'></pt-icon>
</ng-template>

<ng-template #nameCol let-node>
  {{ node.row.fullName }}
</ng-template>
